{
  "slug": "can-anxiety-lower-iq-scores",
  "title": "¿Puede la ansiedad disminuir los puntajes de las pruebas de CI?",
  "description": "La ansiedad puede consumir la atención o la memoria de trabajo, pero los efectos varían.",
  "category": "Preguntas de IQ contestadas",
  "sections": [
    {
      "heading": "Respuesta corta",
      "paragraphs": [
        "La ansiedad puede consumir la atención o la memoria de trabajo, pero los efectos varían."
      ]
    },
    {
      "heading": "Qué le afecta",
      "paragraphs": [
        "La calidad de la prueba, la edad, la salud, el idioma, la educación, la motivación, el entorno y el propósito son todos importantes.",
        "Un efecto promedio del estudio no puede predecir exactamente a una persona."
      ]
    },
    {
      "heading": "Orientación",
      "paragraphs": [
        "Use un sueño adecuado, condiciones tranquilas, acomodaciones y un instrumento adecuado.",
        "Para decisiones relacionadas con los niños, la salud, la discapacidad o las apuestas altas, consulte a un profesional calificado."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "can-iq-change-over-time"],
  "sources": [],
  "faqs": [],
  "summary": "La ansiedad puede consumir la atención o la memoria de trabajo, pero los efectos varían. 18 Julio 2026."
}
